import ODataUtil from "./ODataUtil";
import { deleteItem, patchItem, postItem, ApiRequest } from './ApiUtils';
import WitnessInspection from 'classes/WitnessInspection';
import buildQuery from 'odata-query';

const witnessInspectionEndpoint = "/WitnessInspection";

/**
 * Get witness inspections with OData query support
 */
async function getWitnessInspections(page, per_page, orderByInfo, orderByDirection, search, filters) {
  try {
    const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
      per_page, page, WitnessInspection.expand, orderByInfo, orderByDirection, filters
    );
    const filter = {};
    const isDefaults = filters.find(r => r.defaults);

    if (isDefaults) {
      const defaults = isDefaults.defaults;
      if(defaults.projectId) filter["ihwi/workItem/projectId"] = { eq: { type: 'guid', value: defaults.projectId }};
      if(defaults.inspectionNumber) filter["ihwi/inspection/inspectionNumber"] = defaults.inspectionNumber;
    }

    const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
    const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });

    const data = await ApiRequest(witnessInspectionEndpoint, params);
    return WitnessInspection.convertToTableRows(data);
  } catch (error) {
    console.error('Error fetching witness inspections:', error);
    throw error;
  }
}

/**
 * Add a new witness inspection
 */
async function addWitnessInspection(data) {
  try {
    const resourcePath = `${witnessInspectionEndpoint}/Add`;
    const result = await postItem(resourcePath, '', data);
    return result;
  } catch (error) {
    console.error('Error adding witness inspection:', error);
    throw error;
  }
}

/**
 * Update an existing witness inspection
 */
async function updateWitnessInspection(witnessInspectionId, data) {
  try {
    const resourcePath = `${witnessInspectionEndpoint}/Update`;
    const params = `?witnessInspectionId=${witnessInspectionId}`;
    const result = await patchItem(resourcePath, params, data);
    return result;
  } catch (error) {
    console.error('Error updating witness inspection:', error);
    throw error;
  }
}

/**
 * Delete a witness inspection
 */
async function deleteWitnessInspection(witnessInspectionId) {
  try {
    const resourcePath = `${witnessInspectionEndpoint}/Delete`;
    const params = `?witnessInspectionId=${witnessInspectionId}`;
    const result = await deleteItem(resourcePath, params);
    return result;
  } catch (error) {
    console.error('Error deleting witness inspection:', error);
    throw error;
  }
}

/**
 * Get a specific witness inspection by ID
 */
async function getWitnessInspectionById(witnessInspectionId) {
  try {
    const expand = WitnessInspection.expand;
    const { expand: expandQuery } = ODataUtil.UtilityBuilderNestedv3(
      1,
      0,
      expand,
      null,
      null,
      []
    );

    const params = buildQuery({
      expand: expandQuery,
      filter: { WitnessInspectionId: { eq: { type: 'guid', value: witnessInspectionId } } }
    });

    const response = await fetch(`${witnessInspectionEndpoint}${params}`);
    const result = await response.json();

    if (result.value && result.value.length > 0) {
      return new WitnessInspection(result.value[0]);
    }

    return null;
  } catch (error) {
    console.error('Error fetching witness inspection by ID:', error);
    throw error;
  }
}

export {
  getWitnessInspections,
  addWitnessInspection,
  updateWitnessInspection,
  deleteWitnessInspection,
  getWitnessInspectionById
};
